import { render, staticRenderFns } from "./ProductoReporteData.vue?vue&type=template&id=4adf8dc0&"
import script from "./ProductoReporteData.vue?vue&type=script&lang=js&"
export * from "./ProductoReporteData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports